var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135462",
    "data-name": "Group 135462",
    transform: "translate(-139 -1310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135385",
    "data-name": "Group 135385",
    transform: "translate(8 659)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15500",
    "data-name": "Ellipse 15500",
    cx: 101,
    cy: 101,
    r: 101,
    transform: "translate(131 651)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "corrections",
    transform: "translate(182 1313.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135461",
    "data-name": "Group 135461",
    transform: "translate(0 0.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505710",
    "data-name": "Path 505710",
    d: "M122.72,138.279V200.86a15.371,15.371,0,0,1-15.353,15.353H79.08l-17.72,12.36L39.638,243.727V216.213H15.353A15.371,15.371,0,0,1,0,200.86V138.279a15.369,15.369,0,0,1,15.353-15.353h92.014a15.369,15.369,0,0,1,15.353,15.353Z",
    transform: "translate(0 -84.777)",
    fill: "#f5d34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505711",
    "data-name": "Path 505711",
    d: "M258.95,138.279V200.86A15.371,15.371,0,0,1,243.6,216.213H215.31l-17.72,12.36V122.926H243.6A15.369,15.369,0,0,1,258.95,138.279Z",
    transform: "translate(-136.23 -84.777)",
    fill: "#ffa320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505712",
    "data-name": "Path 505712",
    d: "M325.655,20.4,264.333,81.723l-17.556.722.722-17.556L308.821,3.567A11.9,11.9,0,1,1,325.655,20.4Z",
    transform: "translate(-170.142 -0.08)",
    fill: "#619ced"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135460",
    "data-name": "Group 135460",
    transform: "translate(21.372 62.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505713",
    "data-name": "Path 505713",
    d: "M68.82,199.826h39.989v9.316H68.82Z",
    transform: "translate(-68.82 -199.826)",
    fill: "#ffa320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505714",
    "data-name": "Path 505714",
    d: "M68.82,258.056h39.989v9.316H68.82Z",
    transform: "translate(-68.82 -239.973)",
    fill: "#ffa320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505715",
    "data-name": "Path 505715",
    d: "M68.82,316.286h79.763V325.6H68.82Z",
    transform: "translate(-68.82 -280.12)",
    fill: "#ffa320"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505716",
    "data-name": "Path 505716",
    d: "M325.655,28.138,264.333,89.461l-17.556.722,78.88-78.88a11.906,11.906,0,0,1,0,16.835Z",
    transform: "translate(-170.142 -7.818)",
    fill: "#4773cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505717",
    "data-name": "Path 505717",
    d: "M268.411,212.479l-4.078,4.078-17.556.723.722-17.556,4.078-4.078Z",
    transform: "translate(-170.142 -134.914)",
    fill: "#514c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505718",
    "data-name": "Path 505718",
    d: "M268.411,231.166l-4.078,4.078-17.556.723,13.217-13.217Z",
    transform: "translate(-170.142 -153.601)",
    fill: "#2d2f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505719",
    "data-name": "Path 505719",
    d: "M197.59,316.286h39.774V325.6H197.59Z",
    transform: "translate(-136.23 -218.09)",
    fill: "#f78002"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifi);
export default __webpack_public_path__ + "static/media/modifi.a1169db17515556531fa62ca1e7bfe0f.svg";
export { ForwardRef as ReactComponent };